import React, { useEffect, useRef, useState } from "react";
import { Image } from "react-bootstrap";
import { BsChevronDown } from "react-icons/bs";
import { IoIosClose } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import OrderPickingIcon from "../../assets/icons/OrderPicking.svg";
import plusBorderWhite from "../../assets/icons/Plus-border-white.svg";
import Downarrow from "../../assets/icons/downarrow.svg";
import MinusCircleIcon from "../../assets/icons/minus-circle-icon.svg";
import Package from "../../assets/icons/package.svg";
import DelIcon from "../../assets/icons/DeleteIconCircle.svg";
import PlusCircleIcon from "../../assets/icons/plus-circle-icon.svg";
import ShoppingCartIcon from "../../assets/icons/shopping-cart.svg";
import searchIcon from "../../assets/icons/search.svg";
import projectIconOrder from "../../assets/icons/productIconOrder.svg";
import productIconOrder from "../../assets/icons/product-icon-order.svg";
import Header from "../../layouts/Header";
import {
  AddReturnToWarehouse,
  FetchOrderPickingProduct,
  emptyProductBySupplier,
  FetchPOByProject,
} from "../../redux/actions/action";
import "../../assets/styles/local/OrderPicking.css";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";
import { ADD_RETURN_TO_WAREHOUSE } from "../../redux/constants/type";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";
import CancelWarningModal from "../../components/Dailogs/CancelWarningModal";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import Xicon from "../../assets/icons/Xicon.svg";
import simpleRequest from "../../utils/helpers/simpleRequest";
import AddPurchaseOrderDocument from "./AddPurchaseOrderDocument";

const ReturnToWarehouseSingle = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const productDropRef = useRef(null);
  const purchaseOrderDropRef = useRef(null);

  const fetchProductDropdownData = useSelector(
    (state) => state.user.fetchOrderPickingProductDropdown,
  );
  const addReturnToWarehouseRes = useSelector(
    (state) => state.user.addReturnToWarehouseRes,
  );
  const fetchPOByProjectResponse = useSelector(
    (state) => state.user.fetchPOByProjectResponse,
  );
  const [FetchTranslationList, setFetchTranslationList] = useState([]);
  const t = (key) => FetchTranslationList?.[key] || "";

  const [single, setSingle] = useState(true);
  const [list, setList] = useState(false);
  const [typeField, setTypeField] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [query, setQuery] = useState("");
  const [showProductDrop, setShowProductDrop] = useState(false);
  const [productTableData, setProductTableData] = useState([]);
  const [productBottomTableData, setProductBottomTableData] = useState();
  const [selectedProduct, setsSelectedProduct] = useState(null);
  const [searchItems, setSearchItems] = useState("");
  const type_project_Drop_Ref = useRef(null);
  const [projectSearchPeople, setProjectSearchPeople] = useState("");
  const [showProjectsPeople, setShowProjectsPeople] = useState(false);
  const [projectsData, setProjectsData] = useState([]);
  const [projectId, setProjectId] = useState("");

  const [showPurchaseOrderDrop, setShowPurchaseOrderDrop] = useState(false);
  const [purchaseOrderData, setPurchaseOrderData] = useState([]);
  const [selectedPurchaseOrder, setSelectedPurchaseOrder] = useState(null);
  const [purchaseOrderId, setPurchaseOrderId] = useState(null);
  const [purchaseSupplierId, setPurchaseSupplierId] = useState(null);
  const [purchaseOrderSearch, setPurchaseOrderSearch] = useState("");
  const myAppName = localStorage.getItem("myAppName");
  const isOrderPicking = myAppName === "orderpicking";

  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );
  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      setIsBuildingBlock(
        getAppSideNavOptions.some(
          (x) => x.packageId === process.env.REACT_APP_IS_PREMIUM,
        ),
      );
    }
  }, [getAppSideNavOptions]);

  useEffect(() => {
    if (projectId) dispatch(FetchOrderPickingProduct("itemid-asc", projectId));
    fetchScreenTranslations("Return to Warehouse").then((data) =>
      setFetchTranslationList(data),
    );
  }, [projectId]);

  useEffect(() => {
    if (fetchProductDropdownData != null) {
      if (fetchProductDropdownData?.status) {
        setProductTableData(fetchProductDropdownData?.data);
      }
    }
  }, [fetchProductDropdownData]);

  useEffect(() => {
    if (fetchPOByProjectResponse != null) {
      if (fetchPOByProjectResponse?.status) {
        setPurchaseOrderData(fetchPOByProjectResponse?.data);
      }
    }
  }, [fetchPOByProjectResponse]);

  useEffect(() => {
    if (addReturnToWarehouseRes != null) {
      if (addReturnToWarehouseRes?.status) {
        setsSelectedProduct(null);
        setProductBottomTableData({});
        dispatch({
          type: ADD_RETURN_TO_WAREHOUSE,
          data: {},
        });
        setQtytoPick("");
        if (projectId)
          dispatch(FetchOrderPickingProduct("itemid-asc", projectId));
      }
    }
  }, [addReturnToWarehouseRes]);

  useEffect(() => {
    if (searchItems) {
      if (fetchProductDropdownData != null) {
        if (fetchProductDropdownData?.status) {
          const originalData = fetchProductDropdownData?.data || [];

          const dataToSet = originalData?.filter(
            (name) =>
              name.productPartName ||
              "".toLowerCase().includes(searchItems.toLowerCase()) ||
              name.productPartCode ||
              "".toLowerCase().includes(searchItems.toLowerCase()) ||
              name.productPartDescription
                .toLowerCase()
                .includes(searchItems.toLowerCase()) ||
              // supplier name and item id searching
              name.supplier?.some(
                (supplier) =>
                  supplier.productpartcode
                    ?.toLowerCase()
                    .includes(searchItems.toLowerCase()) ||
                  supplier.suppliername
                    ?.toLowerCase()
                    .includes(searchItems.toLowerCase()) ||
                  supplier.itemid
                    ?.toLowerCase()
                    .includes(searchItems.toLowerCase()),
              ),
          );
          setProductTableData(dataToSet);
        }
      }
    } else {
      setProductTableData(fetchProductDropdownData?.data);
    }
  }, [searchItems, fetchProductDropdownData]);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      productDropRef.current &&
      !productDropRef.current.contains(event.target)
    ) {
      setShowProductDrop(false);
    }
    if (
      purchaseOrderDropRef.current &&
      !purchaseOrderDropRef.current.contains(event.target)
    ) {
      setShowPurchaseOrderDrop(false);
    }
    if (
      type_project_Drop_Ref.current &&
      !type_project_Drop_Ref.current.contains(event.target)
    ) {
      setShowProjectsPeople(false);
    }
  };

  const handleSelectedProduct = (items) => {
    const updatedData = {
      ...items,
      qtyToReturn: parseInt(items?.qtytoPick),
    };
    setProductBottomTableData(updatedData);
    setsSelectedProduct(items.productPartName);
    setShowProductDrop(false);
  };

  const [qtytoPick, setQtytoPick] = useState("");

  const handleInputChange = (e) => {
    e.preventDefault();
    const { value } = e.target;
    const newValue = Number(value);
    setProductBottomTableData({
      ...productBottomTableData,
      newQtyToReturn: newValue,
    });
  };

  const HandleAddPickingOrder = () => {
    if (
      productBottomTableData?.newQtyToReturn >
        productBottomTableData?.instock ||
      productBottomTableData?.newQtyToReturn >
        productBottomTableData?.qtyToReturn ||
      productBottomTableData?.newQtyToReturn === 0 ||
      productBottomTableData?.qtyToReturn === 0 ||
      productBottomTableData?.instock === 0
    ) {
      handleGeneralNotification({
        notificationType: "CUSTOM",
        text: `please adjust qty to pick according to a stock.`,
      });
      return;
    }
    setTypeField("");
    if (!projectId)
      return handleGeneralNotification({
        notificationType: "CUSTOM",
        text: `Please select a project!`,
      });
    if (!productBottomTableData) return;
    const payload = {
      returnToWarehouseqty: [
        {
          orderproductid: productBottomTableData.orderproductid,
          productcode: productBottomTableData.productPartCode,
          productqty:
            productBottomTableData.newQtyToReturn ??
            productBottomTableData.qtyToReturn,
        },
      ],
    };
    dispatch(AddReturnToWarehouse(payload));

    if (screenSize !== "xs" && !isOrderPicking) {
      handleGeneralNotification({
        notificationType: "CUSTOM",
        text: ` Great Job! The product was return.`,
      });
    }
    if (screenSize === "xs" || isOrderPicking) {
      setShowConfirmationModal(true);
    }
  };

  const fetchProjects = async () => {
    const resp = await simpleRequest(`/api/User/ProjectDropdown`, "post", {});
    if (resp.status === true) setProjectsData(resp.data);
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  const screenSize = useScreenSize();
  const [selectedProductMobile, setsSelectedProductMobile] = useState();
  /// Selected product screen ///
  if (
    (screenSize === "xs" || isOrderPicking) &&
    selectedProductMobile &&
    selectedProductMobile?.productPartid &&
    selectedProductMobile?.productPartid !== ""
  ) {
    return (
      <>
        <Header setQuery={setQuery} />
        <div className="container-fluid">
          <div className=" main-wrapper mb-4">
            <div style={{ height: "100vh" }}>
              <div
                style={{
                  display: "flex",
                  // gap: "10px",
                  // justifyContent: "space-between",
                }}
              >
                <div
                  style={{ display: "flex", gap: "1px" }}
                  onClick={() => {
                    history.replace("/stock");
                  }}
                >
                  <div
                    style={{
                      color: "#7F7E7F",
                      fontWeight: "bolder",
                      fontSize: "1.1rem",
                      marginTop: "10px",
                      marginBottom: "15px",
                    }}
                  >
                    {/* Stock */}
                    {t("Stock")}
                  </div>
                  <img
                    alt=""
                    src={Downarrow}
                    style={{
                      opacity: "60%",
                      marginTop: "18px",
                      marginBottom: "15px",
                      width: "15px",
                      height: "12px",
                      transform: "rotate(90deg)",
                      cursor: "pointer",
                    }}
                  />
                </div>
                <div
                  style={{ display: "flex", gap: "5px", marginRight: "20px" }}
                >
                  <img
                    alt=""
                    src={OrderPickingIcon}
                    style={{
                      opacity: "60%",
                      marginTop: "12px",
                      marginBottom: "15px",
                      width: "15px",
                      height: "24px",
                      transform: "rotate(0deg)",
                      cursor: "pointer",
                    }}
                  />
                  <div
                    className="order-picking-head"
                    style={{
                      color: "#7F7E7F",
                      fontWeight: "bolder",
                      marginTop: "11px",
                      marginBottom: "15px",
                      fontSize: "1rem",
                    }}
                  >
                    {/* Return to Warehouse */}
                    {t("Return to Warehouse")}
                  </div>
                </div>
              </div>

              <div className={`${"order-picking-content-mobile"}`}>
                <div className="row">
                  <div className="p-0 col-xl-8">
                    <div
                      className="list-Of-Field"
                      style={{ position: "relative", paddingBottom: "45px" }}
                    >
                      <div className={"choose-project-dropdown-mobile"}>
                        <div
                          className={
                            "project-drop-view-mobile d-flex justify-content-between"
                          }
                        >
                          <p className="productpartcodeTxt">
                            {/* {selectedProductMobile?.productPartCode} */}
                            <img
                              src={selectedProductMobile?.barCode}
                              alt=""
                              style={{ width: "100%", height: "100px" }}
                            />
                          </p>
                        </div>
                      </div>
                      <div>
                        <p style={{ marginTop: "30px", textAlign: "center" }}>
                          {selectedProductMobile?.productPartName}
                        </p>
                      </div>

                      <div>
                        <div className="justify-content-around  mb-4">
                          <div
                            className="d-flex mb-4 w-100 align-items-center justify-content-center"
                            style={{ gap: "20px" }}
                          >
                            <div
                              style={{
                                width: "120px",
                                height: "40px",
                                border: "1px solid rgba(0, 0, 0, 0.3)",
                                borderRadius: "5px",
                                position: "relative",
                              }}
                            >
                              <label
                                style={{
                                  position: "absolute",
                                  top: "-10px",
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  background: "#fff",
                                  padding: "0 5px",
                                  color: "rgba(0, 0, 0, 0.5)",
                                  fontSize: "10px",
                                }}
                              >
                                {/* Color */}
                                {t("Color")}
                              </label>

                              <div
                                className="order-table-output"
                                style={{
                                  display: "flex",
                                  height: "40px",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {selectedProductMobile.color !== null ? (
                                  <span
                                    className="color-circle-order"
                                    style={{
                                      backgroundColor: `${selectedProductMobile.color}`,
                                    }}
                                  ></span>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="gap-3 d-flex justify-content-center align-items-center">
                            <img
                              alt=""
                              src={MinusCircleIcon}
                              className="MinusCircleIcon"
                              onClick={() => {
                                if (productBottomTableData) {
                                  let newValue =
                                    productBottomTableData?.newQtyToReturn
                                      ? parseInt(
                                          productBottomTableData?.newQtyToReturn,
                                        ) - 1
                                      : parseInt(
                                          productBottomTableData.qtyToReturn,
                                        ) - 1;
                                  if (newValue < 0) newValue = 0;
                                  setProductBottomTableData((prevData) => ({
                                    ...prevData,
                                    newQtyToReturn: newValue,
                                  }));
                                }
                              }}
                            />
                            <div
                              className="order-table-output"
                              style={{
                                position: "relative",
                                width: "100%",
                              }}
                            >
                              <label
                                style={{
                                  fontSize: "12px",
                                  position: "absolute",
                                  top: "-10px",
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  background: "#fff",
                                  padding: "0 5px",
                                  color: "rgba(0, 0, 0, 0.5)",
                                }}
                              >
                                Qty to Return
                                {/* {FetchTranslationList[21]?.translation} */}
                              </label>
                              <input
                                style={{
                                  border: "1px solid rgba(0, 0, 0, 0.3)",
                                  borderRadius: "5px",
                                  width: "100%",
                                  height: "40px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  textAlign: "center",
                                }}
                                value={
                                  productBottomTableData?.newQtyToReturn ??
                                  productBottomTableData?.qtyToReturn ??
                                  0
                                }
                                min={0}
                                type="number"
                                onChange={(e) => {
                                  let newValue = +e.target.value;
                                  let inStock = +productBottomTableData.instock;
                                  setProductBottomTableData((prevData) => ({
                                    ...prevData,
                                    newQtyToReturn:
                                      newValue > 0
                                        ? Math.min(inStock, newValue)
                                        : 0,
                                  }));
                                }}
                              />
                            </div>
                            <img
                              alt=""
                              src={PlusCircleIcon}
                              className="PlusCircleIcon"
                              onClick={() => {
                                if (productBottomTableData) {
                                  let newValue =
                                    productBottomTableData?.newQtyToReturn
                                      ? parseInt(
                                          productBottomTableData?.newQtyToReturn,
                                        ) + 1
                                      : parseInt(
                                          productBottomTableData.qtyToReturn,
                                        ) + 1;
                                  if (newValue < 0) newValue = 0;
                                  setProductBottomTableData((prevData) => ({
                                    ...prevData,
                                    newQtyToReturn: newValue,
                                  }));
                                }
                              }}
                            />
                          </div>
                          {productBottomTableData?.newQtyToReturn >
                          productBottomTableData?.qtyToReturn ? (
                            <span style={{ color: "red", marginLeft: "auto" }}>
                              {/* You can't return item above the qtyToReturn */}
                              {t("You can't return item above the qtyToReturn")}
                            </span>
                          ) : null}
                        </div>
                        {/* );
                        })} */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            position: "fixed",
            bottom: "0",
            width: "100%",
            background: "#fafafa",
          }}
        >
          <div style={{ width: "100%", padding: "20px" }}>
            <button
              style={{
                width: "100%",
                backgroundColor: "white",
                border: "1px solid #707070",
                color: "#707070",
                fontWeight: "900",
              }}
              className="worktime-cancel-btn"
              onClick={() => {
                history.replace("/stock");
              }}
            >
              {/* Cancel */}
              {t("Cancel")}
            </button>

            <button
              style={{ width: "100%", marginTop: "7px" }}
              className="worktime-add-btn frc"
              onClick={HandleAddPickingOrder}
            >
              <p>
                {/* Return to Warehouse */}
                {t("Return to Warehouse")}
              </p>
            </button>
          </div>
        </div>

        {showConfirmationModal && (
          <div className="wt-modal-background-mobile">
            <div className="confirmation-modal-div-mobile">
              <div
                style={{
                  marginRight: "80px",
                  marginLeft: "80px",
                  color: "white",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  height: "60vh",
                }}
              >
                <p>
                  {/* The product was successfully return and remove from the
                  project. */}
                  {t(
                    "  The product was successfully return and remove from the  project.",
                  )}
                </p>
                <p style={{ fontWeight: "700" }}>
                  {/* Do you want to keep returning more products for this project. */}
                  {t("You can't return item above the qtyToReturn")}
                </p>
              </div>
              <div
                style={{
                  gap: "10px",
                  width: "100%",
                  position: "fixed",
                  bottom: 30,
                  left: 0,
                  right: 0,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <button
                  type="button"
                  style={{
                    width: "80%",
                    height: "60px",
                    border: "1px solid white",
                    background: "#01246B",
                    fontWeight: "900",
                    color: "white",
                  }}
                  className="btn addParchCancel"
                  onClick={() => {
                    history.replace("/stock");
                  }}
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn addParchCancel"
                  style={{
                    width: "80%",
                    height: "60px",
                    fontWeight: "900",
                    color: "#01246B",
                  }}
                  onClick={() => {
                    setShowConfirmationModal(false);
                    setsSelectedProductMobile();
                  }}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
  const handleClose = () => setModalShow(false);
  const handleCancel = (e) => {
    history.goBack();
  };
  return (
    <>
      <Header
        setQuery={setQuery}
        leftComponent={
          <div className="products-and-parts-header-content">
            <div
              className="products-and-parts-main-title  cursor-pointer"
              onClick={() => {
                history.replace("/stock");
              }}
            >
              {/* Stock */}
              {t("Stock")}
            </div>
            <p className="products-and-parts-sub-title">
              {/* Return to Warehouse */}
              {t("Return to Warehouse")}
            </p>

            <div className="d-flex mainSwitch ms-5 pointer">
              <div
                className={
                  single ? "singleSwitch px-4 py-1" : "noSwitch px-4 py-1"
                }
                onClick={() => {
                  setSingle(true);
                  setList(false);
                  history.replace("/return-to-warehouse-single");
                  dispatch(emptyProductBySupplier());
                }}
              >
                {/* Single */}
                {t("Single")}
              </div>
              <div
                className={list ? "listSwitch px-4 py-1" : "noSwitch px-4 py-1"}
                onClick={() => {
                  setList(true);
                  setSingle(false);
                  history.replace("/return-to-warehouse-list");
                  dispatch(emptyProductBySupplier());
                }}
              >
                {/* List */}
                {t("List")}
              </div>
            </div>
          </div>
        }
      />
      {modalShow && (
        <CancelWarningModal
          show={modalShow}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
        />
      )}
      <RouteLeavingGuard
        when={typeField !== ""}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          if (typeField !== "") {
            if (!["/stock"].includes(location.pathname)) {
              return true;
            }
          }
          return false;
        }}
      />
      <div className="container-fluid">
        <div className=" main-wrapper mb-4">
          <div>
            {(screenSize === "xs" || isOrderPicking) && (
              <div
                style={{
                  display: "flex",
                  // gap: "10px",
                  // justifyContent: "space-between",
                }}
              >
                <div
                  style={{ display: "flex", gap: "1px" }}
                  onClick={() => {
                    history.replace("/stock");
                    dispatch(emptyProductBySupplier());
                  }}
                >
                  <div
                    style={{
                      color: "#7F7E7F",
                      fontWeight: "bolder",
                      fontSize: "1.1rem",
                      marginTop: "10px",
                      marginBottom: "15px",
                    }}
                  >
                    {/* Stock */}
                    {t("Stock")}
                  </div>
                  <img
                    alt=""
                    src={Downarrow}
                    style={{
                      opacity: "60%",
                      marginTop: "18px",
                      marginBottom: "15px",
                      width: "15px",
                      height: "12px",
                      transform: "rotate(90deg)",
                      cursor: "pointer",
                    }}
                  />
                </div>
                <div
                  style={{ display: "flex", gap: "5px", marginRight: "20px" }}
                >
                  <img
                    alt=""
                    src={OrderPickingIcon}
                    style={{
                      opacity: "60%",
                      marginTop: "12px",
                      marginBottom: "15px",
                      width: "15px",
                      height: "24px",
                      transform: "rotate(0deg)",
                      cursor: "pointer",
                    }}
                  />
                  <div
                    style={{
                      color: "#7F7E7F",
                      fontWeight: "bolder",
                      fontSize: "1rem",
                      marginTop: "11px",
                      marginBottom: "15px",
                    }}
                  >
                    {/* Return to Warehouse */}
                    {t("Return to Warehouse")}
                  </div>
                </div>
              </div>
            )}
            <div className="order-picking-header">
              {screenSize !== "xs" && !isOrderPicking && (
                <div className="OrderPicking-action d-flex gap-3 justify-content-end mb-4">
                  <div className="ps-2 me-3" style={{ paddingTop: "0px" }}>
                    <AddPurchaseOrderDocument
                      // poOrderCode={poOrderCode}
                      orderid={purchaseOrderId}
                      isDisabled={true}
                      style={{ height: "42px", borderRadius: "12px" }}
                    />
                  </div>

                  <button
                    className="cancel-btn"
                    onClick={() => {
                      if (typeField !== "") {
                        setModalShow(true);
                      } else {
                        setsSelectedProductMobile();
                        history.replace("/stock");
                      }
                    }}
                  >
                    {/* Cancel */}
                    {t("Cancel")}
                  </button>

                  <button
                    // disabled={selectedProduct == null}
                    className="btn add-btn ms-1"
                    onClick={HandleAddPickingOrder}
                  >
                    {/* Return */}
                    {t("Return")}
                  </button>
                </div>
              )}
            </div>
            <div
              className={`${
                screenSize === "xs" || isOrderPicking
                  ? "order-picking-content-mobile"
                  : "order-picking-content pb-0"
              }`}
            >
              <div className="row">
                <div className="p-0 col-xl-6">
                  <div
                    className="list-Of-Field"
                    style={{ position: "relative" }}
                  >
                    {screenSize === "xs" || isOrderPicking ? (
                      <div className="project-lable d-flex mb-3">
                        <h5
                          className="project-lable-heading"
                          style={{ color: "#323232" }}
                        >
                          {/* Scan or Choose an item */}
                          Choose a project
                          {/* {FetchTranslationList[14]?.translation} */}
                        </h5>
                      </div>
                    ) : (
                      <div className="project-lable d-flex mb-3">
                        <img
                          alt=""
                          src={projectIconOrder}
                          className="project-form-icon"
                        />
                        <h5 className="project-lable-heading">
                          Project
                          {/* {FetchTranslationList[15]?.translation} */}
                        </h5>
                      </div>
                    )}

                    <div
                      className="asc-input-containe-r mt-3"
                      id="ascInput"
                      style={{
                        border: "0.5px solid #70707080",
                        borderRadius: "6px",
                        marginBottom: "3rem",
                      }}
                      ref={type_project_Drop_Ref}
                    >
                      <label
                        className="asc-label-top ClientNameText d-none"
                        style={{ background: "#fff" }}
                      >
                        {/* Project */}
                        {t("Projects")}
                      </label>
                      <input
                        type="text"
                        className="typeSupplier asc_NormalInput ps-3"
                        style={{
                          fontSize: "14px",
                          fontWeight: "700",
                          color: "#323232",
                          width:
                            screenSize === "xs" || isOrderPicking
                              ? "90%"
                              : "93%",
                          border: "unset",
                          background: "white",
                        }}
                        placeholder={t("Type a project")}
                        // placeholder={FetchTranslationList[14]?.translation}
                        value={projectSearchPeople}
                        onChange={(e) => {
                          setProjectSearchPeople(e.target.value);
                          setShowProjectsPeople(true);
                        }}
                        onFocus={() => {
                          setShowProjectsPeople(true);
                          setProjectSearchPeople("");
                          setProjectId("");
                          setTypeField("asc");
                        }}
                      />
                      <img
                        src={Xicon}
                        className={
                          projectSearchPeople || showProjectsPeople
                            ? "purch_xicon pointer mx-2"
                            : "purch_xicon mx-2 invisible"
                        }
                        alt=""
                        onClick={() => {
                          setProjectSearchPeople("");
                          setShowProjectsPeople(!showProjectsPeople);
                          setProjectId("");
                        }}
                      />
                      {showProjectsPeople && (
                        <div
                          className="customSelect_Outer_purch"
                          style={{ height: "unset", zIndex: 1100 }}
                        >
                          <div
                            className="asc_Search_List ps-0"
                            id="ascSelectBox"
                          >
                            {projectsData
                              ?.filter(
                                (item) =>
                                  item.projectname
                                    ?.toLowerCase()
                                    .includes(
                                      projectSearchPeople.toLowerCase(),
                                    ) ||
                                  item.projectcode
                                    ?.toLowerCase()
                                    .includes(
                                      projectSearchPeople.toLowerCase(),
                                    ),
                                // item.lastname?.toLowerCase().includes(projectSearchPeople)
                              )
                              .map((people, index) => {
                                let existItem = false;
                                if (projectId === people.projectid) {
                                  existItem = true;
                                }
                                return (
                                  <div
                                    key={index}
                                    style={{
                                      backgroundColor: existItem
                                        ? "#d8d8e5"
                                        : "",
                                    }}
                                    className="dropDown_peoples_flex ulterDrop w-100 m-0"
                                    onClick={() => {
                                      // setProjectSearchPeople(people.projectname);
                                      setProjectSearchPeople(
                                        `${people.projectcode} ┃ ${people.projectname}`,
                                      );
                                      setProjectId(people.projectid);
                                      setShowProjectsPeople(false);

                                      dispatch(
                                        FetchPOByProject(
                                          people.projectid,
                                          "Purchasing",
                                          // pageNumber,
                                          // itemsPerPage,
                                        ),
                                      );
                                    }}
                                  >
                                    <p className="dropDownPeoples_purch">
                                      {people?.projectcode}
                                      &nbsp;┃&nbsp;
                                      {people?.projectname}
                                    </p>
                                  </div>
                                );
                              })}
                            {projectsData.length === 0 && (
                              <span>
                                {/* No projects to display! */}
                                {t("Asset")}
                              </span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    {isBuildingBlock &&
                      screenSize !== "xs" &&
                      !isOrderPicking && (
                        <div
                          className="list-Of-Field order-pickingimagehide mb-3"
                          style={{ maxWidth: "100%" }}
                        >
                          <div className="project-lable d-flex mb-3">
                            <h5 className="project-lable-heading">
                              Item Image
                              {/* {FetchTranslationList[29]?.translation} */}
                            </h5>
                          </div>
                          <div className="product-order-images w-100">
                            {productBottomTableData?.cover && (
                              <img
                                src={productBottomTableData?.cover}
                                alt=""
                                className="p-2"
                              />
                            )}
                          </div>
                        </div>
                      )}

                    {(screenSize === "xs" || isOrderPicking) && (
                      <div
                        style={{
                          marginTop: "10px",
                          borderTop: "1px dotted #A5A5A5",
                        }}
                      >
                        {productTableData?.map((item) => {
                          return (
                            <div
                              onClick={() => {
                                handleSelectedProduct(item);
                                setsSelectedProductMobile(item);
                                setTypeField("asc");
                              }}
                              style={{
                                display: "flex",
                                gap: "10px",
                                padding: "5px 0",
                                borderBottom: "1px dotted #A5A5A5",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <div style={{ width: "45%" }}>
                                <p
                                  style={{
                                    width: "85%",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    display: "block",
                                    marginBottom: "0",
                                  }}
                                >
                                  {item?.productPartCode}
                                </p>
                                <p
                                  style={{
                                    width: "85%",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    display: "block",
                                    marginBottom: "0",
                                    color: "#323232",
                                  }}
                                >
                                  {item?.productPartName}
                                </p>
                              </div>
                              <span
                                style={{
                                  color: "#323232",
                                }}
                              >
                                {item?.supplier[0]?.qtytoPick}
                              </span>
                              <img
                                alt=""
                                src={Downarrow}
                                style={{
                                  opacity: "20%",
                                  width: "18px",
                                  height: "12px",
                                  transform: "rotate(-90deg)",
                                  cursor: "pointer",
                                }}
                              />
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>

                <div className="p-0 col-xl-6">
                  {/* purchase order start */}
                  <div
                    className="list-Of-Field"
                    style={{
                      position: "relative",
                      maxWidth: "100%",
                      marginBottom:
                        screenSize === "xs" || isOrderPicking ? "30px" : "50px",
                    }}
                    ref={purchaseOrderDropRef}
                  >
                    {screenSize !== "xs" && !isOrderPicking && (
                      <div className="project-lable d-flex mb-3">
                        <img
                          alt=""
                          src={ShoppingCartIcon}
                          className="project-form-icon"
                          style={{ opacity: "70%" }}
                        />
                        <h5 className="project-lable-heading">
                          Purchase Order
                          {/* {FetchTranslationList[11]?.translation} */}
                        </h5>
                      </div>
                    )}
                    {screenSize === "xs" || isOrderPicking ? (
                      <div>
                        <div className="project-search-main-mobile d-none">
                          <img
                            alt=""
                            className="search_pop ms-2 mb-1"
                            src={searchIcon}
                          />
                          <input
                            type="text"
                            value={searchItems}
                            style={{
                              margin: "0 0 0 0.5rem",
                              fontSie: "14px",
                            }}
                            placeholder="Search"
                            // placeholder={FetchTranslationList[24]?.translation}
                            className="search-style select-client-div"
                            onChange={(e) => {
                              setSearchItems(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="choose-project-dropdown">
                        <div
                          onClick={() =>
                            setShowPurchaseOrderDrop(!showPurchaseOrderDrop)
                          }
                          className="project-drop-view d-flex"
                          style={{
                            justifyContent:
                              screenSize === "xs" || isOrderPicking
                                ? "flex-start"
                                : "space-between",
                          }}
                        >
                          <p className="margin-0-pop ordertype ps-2">
                            {selectedPurchaseOrder || "Type a purchase order "}
                            {/* {selectedProject ||
                              FetchTranslationList[12]?.translation} */}
                          </p>

                          <BsChevronDown
                            size={18}
                            className={
                              "down-arrow-pop bi-paperclip ms-4 ms-xxl-3"
                            }
                          />
                        </div>

                        {showPurchaseOrderDrop && (
                          <div className="Outer-project-dropdown ps-0 pe-2">
                            <div className="project-drop d-flex justify-content-between">
                              <p className="mb-2 ps-3">
                                Choose a Purchase Order
                                {/* {FetchTranslationList[65]?.translation} */}
                              </p>
                              <BsChevronDown
                                size={18}
                                onClick={() =>
                                  setShowPurchaseOrderDrop(
                                    !showPurchaseOrderDrop,
                                  )
                                }
                                className={"down-arrow-pop down-arrow-rotate"}
                              />
                            </div>

                            <div
                              className="project-search-main ms-2"
                              style={{ marginBottom: "10px" }}
                            >
                              <img
                                alt=""
                                className="search_pop ms-2 mb-1"
                                src={searchIcon}
                              />
                              <input
                                type="text"
                                value={purchaseOrderSearch}
                                style={{
                                  margin: "0 0 0 0.5rem",
                                  fontSie: "14px",
                                }}
                                placeholder={
                                  // FetchTranslationList[24]?.translation
                                  "Search"
                                }
                                className="search-style select-client-div"
                                onChange={(e) => {
                                  setPurchaseOrderSearch(e.target.value);
                                }}
                              />
                            </div>
                            <div className="my-custom-scrollbar">
                              {purchaseOrderData
                                ?.filter(
                                  (item) =>
                                    item.suppliername
                                      ?.toLowerCase()
                                      .includes(
                                        purchaseOrderSearch.toLowerCase(),
                                      ) ||
                                    item.ordercode
                                      ?.toLowerCase()
                                      .includes(
                                        purchaseOrderSearch.toLowerCase(),
                                      ),
                                )
                                .map((poItem) => {
                                  return (
                                    <p
                                      key={poItem.projectid}
                                      className="mb-0 ps-2 text-for-projects ulterDrop"
                                      style={{
                                        textTransform: "capitalize",
                                        backgroundColor:
                                          purchaseOrderId === poItem.orderid
                                            ? "#F4F5F4"
                                            : "transparent",
                                      }}
                                      onClick={() => {
                                        setSelectedPurchaseOrder(
                                          poItem.suppliername,
                                        );
                                        setPurchaseOrderId(poItem.orderid);
                                        setPurchaseSupplierId(
                                          poItem.supplierid,
                                        );
                                        setShowPurchaseOrderDrop(false);
                                        setTypeField("asc");
                                        // dispatch(
                                        //   ProductProjectDropdown(
                                        //     null,
                                        //     poItem.orderid,
                                        //   ),
                                        // );
                                        // setsSelectedProduct(null);
                                        // setsSelectedQuote(null);
                                        // setShowProductBottomList(false);
                                        // dispatch({
                                        //   type: CREATE_ORDER_PICKING,
                                        //   data: {},
                                        // });
                                        // setCoverImage("");
                                        // setProductTableData([]);
                                        // setProductBottomTableData({});
                                        // setProductId("");
                                      }}
                                    >
                                      {poItem?.ordercode}&nbsp;┃&nbsp;
                                      {poItem.suppliername}
                                    </p>
                                  );
                                })}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  {/* purchase order end */}

                  {screenSize !== "xs" && !isOrderPicking && (
                    <div
                      className={
                        screenSize === "xs" || isOrderPicking
                          ? "choose-project-dropdown-mobile"
                          : "choose-project-dropdown"
                      }
                      ref={productDropRef}
                    >
                      <div className="project-lable d-flex mb-3">
                        <img
                          alt=""
                          src={productIconOrder}
                          className="project-form-icon"
                          style={{ opacity: "70%" }}
                        />
                        <h5 className="project-lable-heading">
                          Item Name
                          {/* {FetchTranslationList[11]?.translation} */}
                        </h5>
                      </div>
                      <div
                        className={
                          screenSize === "xs" || isOrderPicking
                            ? "project-drop-view-mobile d-flex justify-content-between"
                            : "project-drop-view d-flex justify-content-between"
                        }
                      >
                        {screenSize !== "xs" && !isOrderPicking && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                            onClick={() => {
                              setShowProductDrop(!showProductDrop);
                            }}
                          >
                            <p className="margin-0-pop ordertype ps-2">
                              {selectedProduct || "Type or scan an item"}
                              {/* {selectedProduct ||
                                  FetchTranslationList[15]?.translation} */}
                            </p>
                            <BsChevronDown
                              size={18}
                              className={
                                "down-arrow-pop bi-paperclip ms-4 ms-xxl-3"
                              }
                            />
                          </div>
                        )}
                      </div>

                      {showProductDrop && (
                        <div className="add-item-wrapper order-picking-wrapper">
                          <div className="d-flex justify-content-between align-items-center bgdiv">
                            <p className="inputparts px-3">Parts</p>
                            <div className="add-item-title w-100">
                              <input
                                className="update-member-input-noborder add-member-input bgforinput w-100"
                                value={searchItems}
                                onChange={(e) => {
                                  setSearchItems(e.target.value);
                                }}
                                placeholder={
                                  // FetchTranslationList[24]?.translation
                                  "Search"
                                }
                              />
                            </div>
                            <img
                              src={DelIcon}
                              alt=""
                              className="mx-3 cursor-pointer"
                              onClick={() =>
                                setShowProductDrop(!showProductDrop)
                              }
                            />
                          </div>
                          <div className="border-line d-none"></div>
                          <div className="stock-order-items-main gap-0 p-3">
                            {productTableData?.map((items, index) => (
                              <div key={index} className="w-100">
                                <div
                                  className="missing-order-items add-item-title w-100"
                                  onClick={() => {
                                    handleSelectedProduct(items);
                                    setShowProductDrop(!showProductDrop);
                                    setTypeField("asc");
                                    setQtytoPick(parseInt(items.qtytoPick));
                                  }}
                                >
                                  <div className="order-count-title">
                                    {items.productPartName}
                                  </div>
                                  {isBuildingBlock && (
                                    <div className="title-hover">
                                      <div className="items-desc-column4">
                                        <div className="desc-image-wrp4 desc-image4 ">
                                          {items?.cover ? (
                                            <>
                                              <div
                                                className={`product-list-image-default4 ${
                                                  items?.image?.length === 0
                                                    ? "hover-hide4"
                                                    : ""
                                                }`}
                                              >
                                                <img
                                                  src={items?.cover}
                                                  alt=""
                                                  className="cover-image4"
                                                />
                                                {items?.image &&
                                                  items?.image?.length > 0 && (
                                                    <div className="image-row4">
                                                      {items?.image
                                                        .slice(0, 3)
                                                        .map((val, index) => (
                                                          <img
                                                            key={index}
                                                            src={val.image}
                                                            alt={`Images ${
                                                              index + 1
                                                            }`}
                                                          />
                                                        ))}
                                                    </div>
                                                  )}
                                              </div>
                                              {items?.image &&
                                                items?.image?.length > 0 && (
                                                  <span className="desc-image-plus4">
                                                    <Image
                                                      height={10}
                                                      width={10}
                                                      src={plusBorderWhite}
                                                    />
                                                  </span>
                                                )}
                                            </>
                                          ) : (
                                            <div className="product-list-default4">
                                              <img
                                                src={Package}
                                                alt=""
                                                className="default-img4"
                                              />
                                              <div className="product-image-title4 d-none">
                                                Picture
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div className="count-col">
                                    <div className="stock-order-col ps-4">
                                      {/* Stock */}
                                      {t("Worktime")}
                                    </div>
                                  </div>

                                  <div className="stock-items">
                                    <div className="d-flex align-items-center gap-3 justify-content-center">
                                      <div className="d-flex flex-column align-items-center justify-content-center gap-1">
                                        <div
                                          style={{
                                            backgroundColor: `${items.color}`,
                                          }}
                                          className="color-code ms-4 mx-3"
                                        ></div>
                                      </div>

                                      <div className="info-items">
                                        {items.instock}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {screenSize !== "xs" && !isOrderPicking && (
                    <div className="product-list-Field pt-5">
                      <div className="d-flex flex-wrap gap-3 items-row">
                        <div className="order-table-th col-md-3">
                          <h3 className="order-table-heading">
                            {/* Item ID */}
                            {t("Item ID")}
                          </h3>
                          <div className="order-table-td">
                            <div className="order-table-output">
                              {productBottomTableData?.productPartCode}
                            </div>
                          </div>
                        </div>
                        <div className="order-table-th col-md-2">
                          <h3 className="order-table-heading">
                            {/* Kg */}
                            {t("Kg")}
                          </h3>
                          <div className="order-table-td">
                            <div className="order-table-output">
                              {productBottomTableData?.kg}
                            </div>
                          </div>
                        </div>

                        <div className="order-table-th col-md-2 ms-auto">
                          <h3 className="order-table-heading">
                            {/* Qty to Return */}
                            {t("Qty to Return")}
                          </h3>
                          <div className="d-flex justify-content-center">
                            <div className="order-table-output pt-0">
                              <input
                                value={
                                  // productBottomTableData?.newQtyToReturn ??
                                  // productBottomTableData?.qtyToReturn ??
                                  // 0

                                  productBottomTableData?.newQtyToReturn ??
                                  productBottomTableData?.qtyToReturn ??
                                  qtytoPick ??
                                  0
                                }
                                type="number"
                                min={0}
                                onChange={(e) => handleInputChange(e)}
                                style={{
                                  border: "none",
                                  height: "inherit",
                                  width: "100%",
                                  textAlign: "center",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        {productBottomTableData?.newQtyToReturn >
                        productBottomTableData?.qtyToReturn ? (
                          <span style={{ color: "red", marginLeft: "auto" }}>
                            {/* You can't return item above the qtyToReturn */}
                            {t("You can't return item above the qtyToReturn")}
                          </span>
                        ) : null}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReturnToWarehouseSingle;
